import { Instagram, Link2, MessageCircle, Share2 } from "lucide-react";
import { toast } from "sonner";
import { useStore } from "@/context/StoreContext";
import { formatIDR } from "@/data/products";
import { IG_LINK } from "@/i18n";

export default function ShareButtons({ product: p }) {
  const { t } = useStore();
  const url = `${window.location.origin}/?produk=${p.id}`;
  const text = `${t.product.shareMsg} ${p.name} — ${formatIDR(p.price)}\n${url}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      window.prompt("Copy:", url);
    }
    toast.success(t.product.copied);
  };

  const shareIg = async () => {
    await copy();
    window.open(IG_LINK, "_blank", "noopener");
  };

  const btn =
    "flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-mist transition-colors hover:border-ember hover:text-ember";

  return (
    <div className="flex items-center gap-2" data-testid="share-buttons">
      <span className="mr-1 flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
        <Share2 size={12} /> {t.product.share}
      </span>
      <a
        data-testid="share-whatsapp"
        href={`https://wa.me/?text=${encodeURIComponent(text)}`}
        target="_blank"
        rel="noopener noreferrer"
        className={btn}
        aria-label="WhatsApp"
      >
        <MessageCircle size={14} />
      </a>
      <button data-testid="share-instagram" onClick={shareIg} className={btn} aria-label="Instagram">
        <Instagram size={14} />
      </button>
      <button data-testid="share-copy" onClick={copy} className={btn} aria-label={t.product.copyLink}>
        <Link2 size={14} />
      </button>
    </div>
  );
}
